// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// Your web app's Firebase configuration (replace this with your config)
const firebaseConfig = {
    apiKey: "AIzaSyAd1V6WWtPobcZh7_dMOs3MYB04q8uDbMk",
    authDomain: "crunch-app-20105.firebaseapp.com",
    projectId: "crunch-app-20105",
    storageBucket: "crunch-app-20105.appspot.com",
    messagingSenderId: "686366779197",
    appId: "1:686366779197:web:a19ce7c53584afbd678754",
    measurementId: "G-KH2Z4F5DVE"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
export { auth, db };
